module.exports = __webpack_public_path__ + "static/media/banner-ourevents_Ch_design.d870dc2e.png";